import { LocalizationDictionary } from "./Localization";

export const engineLocalizationDictionary: LocalizationDictionary = {
    en: {},
};
